module.exports = __webpack_public_path__ + "img/man_zombie.bf891728.gif";